import React from 'react';
import { formatNum } from '../../utils/dashboardFormatters';

export default function DashboardTodayStrip({ today, loading }) {
  if (loading || !today) return null;
  const items = [
    { icon: 'fa-user-plus', label: 'New users today', value: today.newUsersToday },
    { icon: 'fa-bell', label: 'Alerts today', value: today.alertsToday },
    { icon: 'fa-paper-plane', label: 'Campaigns sent today', value: today.campaignsToday },
  ];
  return (
    <div className="db-today-strip" aria-label="Today snapshot">
      {items.map((item) => (
        <span key={item.label} className="db-today-pill">
          <i className={`fas ${item.icon}`} />
          {item.label}: <strong>{formatNum(item.value ?? 0)}</strong>
        </span>
      ))}
    </div>
  );
}
